// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Slb","top":"styles_top__3FswY","left":"styles_left__3-QHx","description":"styles_description__3A8HQ"};